import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {ResetStatus, SaveDuringResetStatus, SaveStatus} from './common'
import {change as changePasswordSettings, create as createPasswordSettings, PasswordValidatorId, toggleRuleId} from '../../util/passwords/PasswordSettings'

export default function createReducer({PASSWORD_SETTINGS = {}, IS_USER_PASSWORD_MATCHES_POLICY = false} = {}) {
    const initState = {
        settings: createPasswordSettings(PASSWORD_SETTINGS),
        initialSettings: createPasswordSettings(PASSWORD_SETTINGS),

        configurableRuleIds: [PasswordValidatorId.UPPERCASE_VALIDATOR,
                              PasswordValidatorId.LOWERCASE_VALIDATOR,
                              PasswordValidatorId.NUMBER_VALIDATOR,
                              PasswordValidatorId.SPECIAL_VALIDATOR
        ],
        minimalLengthError: null,
        settingsGotStronger: false,

        saveStatus: SaveStatus.Initial,
        resetStatus: ResetStatus.Initial,
        passwordNotResetFor: [],
        currentPassword: '',
        newPassword: '',
        currentPasswordInvalid: false,
        newPasswordInvalid: false,

        passwordValidationResult: {},

        isUserPasswordMatchesPolicy: IS_USER_PASSWORD_MATCHES_POLICY,
    }

    return handleActions({
        [ActionTypes.PASSWORD_STRONGER_FLAG_SET]: (state, {payload: flag}) => ({
            ...state,
            settingsGotStronger: flag
        }),
        [ActionTypes.PASSWORD_REQUIREMENT_SET]: (state, {payload: {id, value}}) => ({
            ...state,
            settings: toggleRuleId(state.settings, id, value),
            saveStatus: SaveStatus.Modified
        }),
        [ActionTypes.PASSWORD_MIN_LENGTH_SET]: (state, {payload: val}) => ({
            ...state,
            settings: changePasswordSettings(state.settings, {minimalLength: val}),
            minimalLengthError: null,
            saveStatus: SaveStatus.Modified
        }),

        [ActionTypes.CURRENT_PASSWORD_SET]: (state, {payload: password}) => ({
            ...state,
            currentPassword: password,
            currentPasswordInvalid: password.length === 0,
        }),

        [ActionTypes.NEW_PASSWORD_SET]: (state, {payload: password}) => ({
            ...state,
            newPassword: password,
            newPasswordInvalid: password.length === 0,
        }),

        [ActionTypes.PASSWORDS_CLEAR]: (state) => ({
            ...state,
            currentPassword: '',
            newPassword: '',
        }),

        [ActionTypes.CURRENT_PASSWORD_INVALID_SET]: (state, {payload: flag}) => ({
            ...state,
            currentPasswordInvalid: flag,
        }),

        [ActionTypes.NEW_PASSWORD_INVALID_SET]: (state, {payload: flag}) => ({
            ...state,
            newPasswordInvalid: flag,
        }),

        [ActionTypes.PASSWORD_VALIDATION_RESULT_SET]: (state, {payload: result}) => ({
            ...state,
            passwordValidationResult: result,
        }),

        [ActionTypes.USER_PASSWORD_MATCHES_PASSWORD_POLICY_SET]: (state, {payload: flag}) => ({
            ...state,
            isUserPasswordMatchesPolicy: flag,
        }),

        [ActionTypes.PASSWORD_MIN_LENGTH_ERROR_SET]: (state, {payload: error}) => ({
            ...state,
            minimalLengthError: error
        }),
        [ActionTypes.RESET_STARTED]: (state) => ({
            ...state,
            passwordNotResetFor: [],
            resetStatus: state.saveStatus === SaveStatus.Modified ? ResetStatus.ResettingAndSaving : ResetStatus.Resetting,
        }),
        [ActionTypes.RESET_COMPLETED]: (state) => ({
            ...state,
            saveStatus: SaveStatus.Saved,
            settingsGotStronger: false,
            initialSettings: createPasswordSettings(state.settings),
            resetStatus: state.resetStatus === ResetStatus.ResettingAndSaving ? ResetStatus.ResetAndSaveDone : ResetStatus.ResetDone
        }),
        [ActionTypes.RESET_FAILED]: (state) => ({
            ...state,
            resetStatus: ResetStatus.Initial,
        }),
        [ActionTypes.RESET_RESULT_SET_PASSWORD_NOT_RESET_FOR]: (state, {payload: passwordNotResetFor}) => ({
            ...state,
            passwordNotResetFor
        })
    }, initState)
}


// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/reducer.js